module.exports = __webpack_public_path__ + "static/media/Portrait-10272.0f6a14fe.jpg";